import { useEffect, useState } from "react";
import "./Header.css";

export default function Header({ page1Ref }) {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!page1Ref?.current) return;
      const bottom = page1Ref.current.getBoundingClientRect().bottom;

      // Sticky solo después de pasar page1
      setIsSticky(bottom <= 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [page1Ref]);

  const logoSrc = isSticky ? "/banner.png" : "/logo-small.png";

  return (
    <header className={`App-header ${isSticky ? "sticky white-bg" : ""}`}>
      <img
        src={logoSrc}
        className={`App-logo ${isSticky ? "logo-banner" : "logo-small"}`}
        alt="logo"
      />
    </header>
  );
}
